import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const seloInstavel: TechniqueDefinition = {
  id: "selo_instavel",
  name: "Selo Instável",
  description:
    "Marks a point with an unstable seal that detonates after a fixed warning.",
  family: "fuinjutsu",
  proficiency: "ninjutsu",
  targeting: "point_area",
  behavior: { kind: "damage" },
  levels: {
    1: {
      chakraCost: 30,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 14,
      attackCoefficient: 1.1,
      radius: 68,
    },
    2: {
      chakraCost: 31,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 15,
      attackCoefficient: 1.14,
      radius: 70,
    },
    3: {
      chakraCost: 32,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 16,
      attackCoefficient: 1.19,
      radius: 72,
    },
    4: {
      chakraCost: 33,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 17,
      attackCoefficient: 1.23,
      radius: 74,
    },
    5: {
      chakraCost: 34,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 18,
      attackCoefficient: 1.28,
      radius: 76,
    },
    6: {
      chakraCost: 35,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 19,
      attackCoefficient: 1.32,
      radius: 78,
    },
    7: {
      chakraCost: 36,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 20,
      attackCoefficient: 1.37,
      radius: 80,
    },
    8: {
      chakraCost: 37,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 20,
      attackCoefficient: 1.41,
      radius: 82,
    },
    9: {
      chakraCost: 38,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 21,
      attackCoefficient: 1.46,
      radius: 84,
    },
    10: {
      chakraCost: 39,
      cooldownMs: 10_000,
      impactDelayMs: 2_000,
      range: 180,
      maxTargets: 5,
      power: 22,
      attackCoefficient: 1.5,
      radius: 86,
    },
  },
  visual: {
    effectId: 225,
    castEffectId: null,
    areaImpactEffectId: 225,
    impactEffectId: null,
  },
};
